import { faCalendarDays, faFileLines } from '@fortawesome/free-solid-svg-icons';
import Calendar from "./pages/Calendar";
import OrdersPage from "./pages/Orders";

export const routes = [
    { path: '/calendar', name: 'Εφαρμογή Παραγγελιών',layout:'/user', component: <Calendar/>, icon: faCalendarDays },
    { path: '/orders', name: 'Ιστορικό Παραγγελιών',layout:'/user', component: <OrdersPage/>,  icon: faFileLines},
  ];
